import { useState } from "react";
import { Loader2, SearchCheck, Check, X, ChevronDown } from "lucide-react";
import { toast } from "sonner";
import { http, errMsg } from "../../../lib/api";

const Row = ({ p, it, setP }) => {
  const [text, setText] = useState(it.text);
  const act = async (action) => {
    try { const { data } = await http.post(`/extras/products/${p.id}/fixups/${it.id}`, { action, text }); setP(data); toast.success(action === "apply" ? `Added to "${it.section}"` : "Dismissed"); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid={`fixup-${it.id}`} className="border-t border-[#EFE9E0] py-3 grid md:grid-cols-[1fr_auto] gap-3">
      <div>
        <div className="text-xs text-stone-500">Belongs in <b className="text-stone-700">{it.section}</b>{it.why ? ` · ${it.why}` : ""}</div>
        <textarea data-testid={`fixup-${it.id}-text`} value={text} onChange={(e) => setText(e.target.value)} rows={2} className="w-full mt-1 border border-stone-300 rounded-sm p-2 text-sm" />
      </div>
      <div className="flex md:flex-col gap-2">
        <button data-testid={`fixup-${it.id}-apply`} onClick={() => act("apply")} className="inline-flex items-center gap-1.5 bg-[#30271D] text-white px-3 py-1.5 text-xs"><Check size={12} /> Add it</button>
        <button data-testid={`fixup-${it.id}-dismiss`} onClick={() => act("dismiss")} className="inline-flex items-center gap-1.5 border border-stone-300 px-3 py-1.5 text-xs"><X size={12} /> Dismiss</button>
      </div>
    </div>
  );
};

export const Fixups = ({ p, setP, reload }) => {
  const [open, setOpen] = useState(true);
  const fx = p.fixups || {};
  const items = (fx.items || []).filter((i) => i.status === "open");
  const done = (fx.items || []).length - items.length;
  const check = async () => { try { await http.post(`/extras/products/${p.id}/fixups/check`); toast.success("Comparing with your original PDF…"); reload(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div data-testid="fixups-panel" className="ex-card px-5 py-4 mb-5">
      <div className="flex flex-wrap items-center gap-3">
        <SearchCheck size={18} className="text-[#8B6B4A]" />
        <div>
          <button data-testid="fixups-toggle" onClick={() => setOpen(!open)} className="flex items-center gap-2 ex-display text-xl">Fix-up suggestions <ChevronDown size={14} className={open ? "rotate-180" : ""} /></button>
          <div data-testid="fixups-status" className="text-xs text-stone-500">
            {p.busy === "fixups" ? "Checking…" : !fx.checked_at ? "Check what from your original PDF didn't make it into the restyled version." : items.length ? `${items.length} thing(s) from your original may be missing` : `Nothing missing${done ? ` · ${done} handled` : ""}`}
            {fx.checked_at ? ` · checked ${new Date(fx.checked_at).toLocaleDateString("en-AU")}` : ""}
          </div>
        </div>
        <button data-testid="fixups-check-button" disabled={!!p.busy} onClick={check} className="ml-auto inline-flex items-center gap-1.5 border border-stone-300 bg-white px-4 py-2 text-sm hover:bg-stone-50 disabled:opacity-40">
          {p.busy === "fixups" ? <Loader2 size={13} className="animate-spin" /> : <Check size={13} />} {fx.checked_at ? "Check again" : "Check for missing content"}</button>
      </div>
      {open && items.length > 0 && <div data-testid="fixups-list" className="mt-3">{items.map((it) => <Row key={it.id} p={p} it={it} setP={setP} />)}</div>}
      {open && !fx.checked_at && <p className="text-xs text-stone-500 mt-2">The AI compares your uploaded PDF with the restyled version and lists any facts, tips, prices or warnings that didn't make it across. You choose what to add.</p>}
    </div>
  );
};
